import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Button, Radio } from 'antd'
import '../../css/messages.scss'
import {
  deleteMessages,
  getMessageList,
} from '../../store/action/callback.action'
import Checkbox from 'antd/lib/checkbox/Checkbox'
import { RedoOutlined } from '@ant-design/icons'
import {
  fechactioncase,
  deleteActionCase,
  messageSelectBox,
  messageGroupBy,
} from '../../store/action/actioncases.action'
import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { constants } from '../../constants'
import util from '../../util/util'
import { messageScope } from '../../util/messagefilter'
import _ from 'lodash'
const MessageAction = (props) => {
  var history = useHistory()
  let filter = { archived: false }
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (history.location.state?.status)
      filter.status = [history.location.state?.status]
    if (history.location.state?.filters?.caseNumbers)
      filter.caseNumbers = history.location.state?.filters.caseNumbers
    if (history.location.state?.customerid)
      filter.customerIds = [history.location.state?.customerid]
    if (props.user?.role == constants.ROLE.SURGEON || props.user?.surgeon) {
      filter.surgeonId = props.user?.surgeon
    }

    filter.customerIds = [props?.decoded?.customer]

    const intervalId = setInterval(
      handleRefresh,
      60000 * constants.message_refresh_time
    ) //5 min

    return () => clearInterval(intervalId)
  }, [])

  // const handleDelete = () => {
  //     if ( props.selectedRequests?.key && props.selectedRequests.key.length > 0) {
  //         props.deleteMessages(props.selectedRequests?.key)
  //         .then(res => {
  //             if (res) {
  //                 props.fetchList({
  //                     ...props.filters,
  //                     sort: props.sort,
  //                     pagination: {pageSize: 20, current: 1},
  //                 }, {})
  //             }
  //         })
  //     }
  // }
  const handleDelete = () => {
    if (props.user?.role == constants.ROLE.SURGEON || props.user?.surgeon) {
      filter.surgeonId = props.user?.surgeon
    }
    filter = { ...filter, ...props.msgfilter }
    filter = {
      ...filter,
      ...messageScope({
        customer: props.customer,
        decoded: props.decoded,
      }),
    }
    if (props.selectedRequests?.key && props.selectedRequests.key.length > 0) {
      props.deleteActionCase(props.selectedRequests?.key).then((res) => {
        props.fechactioncase({
          metadata: { current: 1, pageSize: 20 },
          filters: !_.isEmpty(props.selectedIndex)
            ? { ...filter, surgeonId: props.selectedIndex }
            : filter,
          sorter: { field: 'lastUpdated', order: 'descend' },
        })
      })
    }
  }
  // const handleRefresh = () => {
  //     setLoading(true);
  //     props.fetchList({
  //         ...props.filters,
  //         sort: props.sort,
  //         pagination: {pageSize: 20, current: 1},
  //     }, {})
  //     .then(e => {
  //         setLoading(false);
  //     })
  // }
  // filter.surgeonId=props.user?.surgeon
  const handleRefresh = () => {
    // if(!props.groupby)props.selectedIndex(null) //not selected
    if (props.user?.role == constants.ROLE.SURGEON || props.user?.surgeon) {
      filter.surgeonId = props.user?.surgeon
    }
    filter = { ...filter, ...props.msgfilter }
    if (!_.isEmpty(props.selectedIndex) && props.groupby)
      filter.surgeonId = props.selectedIndex
    setLoading(true)
    filter = {
      ...filter,
      ...messageScope({
        customer: props.customer,
        decoded: props.decoded,
      }),
    }
    props
      .fechactioncase({
        metadata: { current: 1, pageSize: 20 },
        filters: filter,
        sorter: { field: 'lastUpdated', order: 'descend' },
      })
      .then((e) => {
        setLoading(false)
      })
  }

  const handleSurgeon = (checked) => {
    // props.setGroup(checked);
    props.messageGroupBy(checked)
    // handleRefresh()
    //    if(!checked) props.selectedIndex(null)
  }
  return (
    <>
      <Row className={'actionRow'}>
        <Col flex={'30%'}>
          <Row className={'headerText'} align='middle' wrap={false} gutter={5}>
            <Col> Messages </Col>
            <Col>
              <Button
                className='refresh-btn'
                type='ghost'
                shape='circle'
                onClick={handleRefresh}
                loading={loading}
                icon={<RedoOutlined />}
              ></Button>
            </Col>
          </Row>
          {/* hidden={!props.showBtn} */}
          <Row hidden={!props.showBtn}>
            <Checkbox
              onChange={(e) => handleSurgeon(e.target.checked)}
              checked={props.groupby}
            >
              By Providers
            </Checkbox>
          </Row>
        </Col>
        <Col style={{ alignSelf: 'flex-end' }} flex={'auto'}>
          <Row justify={'end'} align={'middle'}>
            <Button
              id={'archivemessage'}
              onClick={handleDelete}
              className={'actionBtn'}
            >
              Archive
              {props.selectedRequests?.key &&
                props.selectedRequests.key.length > 0 &&
                '  (' + props.selectedRequests?.key?.length + ')'}
            </Button>
          </Row>
        </Col>
      </Row>
    </>
  )
}

MessageAction.propTypes = {
  selectedRequests: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    selectedRequests: state.message?.selectedRequests,
    decoded: util.verifyToken(state.profile.token, true),
    filters: state.message.filters,
    pagination: state.message.pagination,
    sort: state.message.sort,
    user: state.profile.user,
    customer: state.profile.customer,
    selectedIndex: state.message.selectedIndex,
    groupby: state.message.groupby,
    msgfilter: state.message.filter,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteMessages: (ids) => dispatch(deleteMessages(ids)),
    fetchList: (filter, selected) => dispatch(getMessageList(filter, selected)),
    fechactioncase: (params) => dispatch(fechactioncase(params)),
    deleteActionCase: (ids) => dispatch(deleteActionCase(ids)),
    messageSelectBox: (data) => dispatch(messageSelectBox(data)),
    messageGroupBy: (data) => dispatch(messageGroupBy(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageAction)
